import React from 'react'
import PropTypes from 'prop-types'
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, CategoryScale, ArcElement } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
// Registrar los componentes de Chart.js
ChartJS.register(CategoryScale, ChartDataLabels, ArcElement)

const KpiCustomGraphicPie = ({
  pieDataStatus = {
    labels: ['Dato1', 'Dato2'],
    datasets: [
      {
        label: 'Generados',
        data: [50, 50],
        backgroundColor: ['#F97316', '#FC8C3C'],
        borderColor: ['#F97316', '#FC8C3C'],
        borderWidth: 1,
      },
    ],
  },
  pieOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  },
  fromPdf = false,
  legendCustom = false,
}) => {
  return (
    <div className="px-1 kpi-graphicsPie">
      <div className="row kpi-card-container kpi-card-containerMini">
        {pieDataStatus && pieOptions && (
          <>
            {legendCustom && (
              <div
                style={{
                  marginBottom: 10,
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 10,
                }}
              >
                {pieDataStatus.labels.map((label, idx) => (
                  <div
                    key={idx}
                    style={{ display: 'flex', alignItems: 'center', gap: 2 }}
                  >
                    <span
                      style={{
                        display: 'inline-block',
                        width: 20,
                        height: 12,
                        background:
                          pieDataStatus.datasets[0].backgroundColor[idx],
                        borderRadius: 2,
                        marginRight: 1,
                      }}
                    />
                    <span
                      style={{
                        color: '#4A4A4A',
                        fontWeight: 'bold',
                        fontSize: 12,
                      }}
                    >
                      {label}
                    </span>
                  </div>
                ))}
              </div>
            )}
            <Pie data={pieDataStatus} options={pieOptions} />
          </>
        )}
      </div>
    </div>
  )
}

KpiCustomGraphicPie.propTypes = {
  barDataStatus: PropTypes.object,
  barOptions: PropTypes.object,
}

export default KpiCustomGraphicPie
